import axios from "axios";
import { baseUrl } from '../config/clientsConfig'

const TodayTeamActivityService = {
    getTodayActivity: async (memberId, teamId, bookingStage, registrationStage) => {
        return axios.get(
            `${baseUrl}/analytics/todayTeamActivity?userId=${memberId}&teamId=${teamId}&bookingStage=${bookingStage}&registrationStage=${registrationStage}`

         );

    }
}
export default TodayTeamActivityService;